module.exports = __webpack_public_path__ + "static/media/rams-poster.acb27bce.png";